import * as messenger from './messenger';
import { Messages } from './messages';
import { Storage } from './storage';
import hyperid from 'hyperid';

export class ExtensionStorage<StorageI extends Record<string, any> = any> implements Storage<StorageI> {
	private hyperidInstance = hyperid();

	public get<Key extends keyof StorageI | undefined = undefined>(
		key?: Key
	): Promise<Key extends undefined ? StorageI : Key extends keyof StorageI ? StorageI[Key] : never> {
		return new Promise(resolve => {
			const requestId = this.generateRequestId();

			messenger.subscribe(requestId, resolve);
			messenger.publish(Messages.Get, {
				requestId,
				key: key as string
			});
		});
	}

	public set<Data extends Partial<StorageI>>(data: Data): Promise<boolean> {
		return new Promise(resolve => {
			const requestId = this.generateRequestId();

			messenger.subscribe(requestId, resolve);
			messenger.publish(Messages.Set, {
				requestId,
				data
			});
		});
	}

	public remove<Key extends keyof StorageI>(key: Key): Promise<boolean> {
		return new Promise(resolve => {
			const requestId = this.generateRequestId();

			messenger.subscribe(requestId, resolve);
			messenger.publish(Messages.Remove, {
				requestId,
				key: key as string
			});
		});
	}

	private generateRequestId() {
		return this.hyperidInstance();
	}
}
